import CookieConsent, { Cookies } from "react-cookie-consent";
import { useConfig } from "../../contexts/ConfigContext";
import { useParentBridge } from "../../hooks/useParentBridge";

export default function CookieAccept() {
  const { postToParent } = useParentBridge();
  const { config } = useConfig();
  const privacyPolicyUrl = config?.REACT_APP_PRIVACY_POLICY_URL || "https://dev.complaintportal.ombudsman.org.uk/documents/privacy-policy.pdf";
  // SameSite=None (with Secure) is required for cookies to persist in a cross-site iframe on production (HTTPS).
  // Lax is used locally (HTTP) because browsers reject SameSite=None on non-secure origins.
  const sameSite = window.location.protocol === "https:" ? "none" : "lax";

  const handlePrivacyLinkClick = (e) => {
    e.preventDefault();
    postToParent({ type: "OPEN_EXTERNAL_URL", url: privacyPolicyUrl });
  };

  const RemoveCookies = () => {
    Cookies.remove("_ga");
    Cookies.remove("_ga_3N506CR6PZ");
    Cookies.remove("VstsSession");
    Cookies.remove("SpsAuthenticatedUser");
  };

  return (
    <CookieConsent
      enableDeclineButton
      flipButtons
      location="bottom"
      buttonText="OK, I agree"
      ariaAcceptLabel="OK, I agree"
      style={{ background: "#000000", fontSize: "1.1rem", padding: "16px" }}
      buttonStyle={{
        backgroundColor: "#732E6B",
        padding: "8px 20px",
        border: "2px solid #732E6B",
        color: "white",
        fontSize: "1.2rem",
      }}
      declineButtonStyle={{
        margin: "10px 10px 10px 0",
        padding: "8px 20px",
        backgroundColor: "#000",
        border: "2px solid white",
        color: "white",
        fontSize: "1.2rem",
      }}
      onDecline={RemoveCookies}
      declineButtonText="No, thanks"
      ariaDeclineLabel="No, thanks"
      sameSite={sameSite}
      expires={150}
    >
      We use cookies on this site to enhance your user experience <br />
      By clicking any link on this page you are giving your consent for us to
      set cookies. <br />
      <a
        href={privacyPolicyUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "white",
          fontSize: "16px",
          fontWeight: "600",
          padding: "0",
        }}
      >
        More info
      </a>
    </CookieConsent>
  );
}
